// extracted by mini-css-extract-plugin
module.exports = {"navigation":"BottomBar_navigation__3r595","active":"BottomBar_active__2RQAT","icon":"BottomBar_icon__1fN0J"};